document.addEventListener("DOMContentLoaded", function () {
  const arButtons = document.querySelectorAll(".ar-button");

  if (arButtons.length > 0) {
    arButtons.forEach((arButton) => {
      arButton.addEventListener("click", function () {
        const modelPoster = document.querySelector(".model-poster");

        if (modelPoster) {
          modelPoster.click();
        } else {
          const threeDIcon = document.querySelector(".icon .bg");

          if (threeDIcon) {
            threeDIcon.closest("button").click();
          } else {
            const modelViewer = document.querySelector("model-viewer");
            if (modelViewer) {
              if (typeof modelViewer.activateAR === "function") {
                modelViewer.activateAR();
              } else {
                console.error("activateAR function not found on model-viewer");
              }
            } else {
              console.error("No 3D viewer elements found");
            }
          }
        }
      });
    });
  } else {
    console.error("No AR Buttons found");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const mediaContainer = document.querySelector(".product__media");
  const mediaItems = mediaContainer.querySelectorAll(".product__media-item");
  const progressBarSegments = document.querySelector(".progress-bar__segments");
  const progressBarFill = document.querySelector(".progress-bar__fill");
  let currentIndex = 0;

  const mediaItemsArr = Array.from(mediaItems);

  function getCurrentIndex() {
    currentIndex = mediaItemsArr.findIndex((item) =>
      item.classList.contains("is-selected")
    );
    return currentIndex;
  }

  mediaItems.forEach((_, index) => {
    const segment = document.createElement("div");
    segment.classList.add("progress-bar-segment");
    segment.setAttribute("data-index", index);
    progressBarSegments.appendChild(segment);
  });

  // Set grid template columns
  progressBarSegments.style.gridTemplateColumns = `repeat(${mediaItems.length}, 1fr)`;

  function updateProgressBar() {
    getCurrentIndex();
    if (progressBarFill) {
      // Update the fill to cover only the current segment
      progressBarFill.style.gridColumn = `${currentIndex + 1} / span 1`;
    }

    // Update active segment
    document
      .querySelectorAll(".progress-bar-segment")
      .forEach((segment, index) => {
        if (index === currentIndex) {
          segment.classList.add("active");
        } else {
          segment.classList.remove("active");
        }
      });
  }

  updateProgressBar();

  // Listen for changes to the is-selected class
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        updateProgressBar();
      }
    });
  });

  mediaItemsArr.forEach((item) => {
    observer.observe(item, { attributes: true });
  });
});

// Pagination logic applied to slider, to slide in steps of n: items.length
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".thumbnail-slider__inner");
  // Arrows
  const leftArrow = document.querySelector(".thumbnail-slider__arrow--left");
  const rightArrow = document.querySelector(".thumbnail-slider__arrow--right");
  const items = slider.querySelectorAll(".thumbnail-slider__item");

  function getVisibleItemsCount() {
    const sliderWidth = slider.offsetWidth;
    const itemWidth = items[0].offsetWidth;
    return Math.floor(sliderWidth / itemWidth) + 2;
  }

  function updateArrowVisibility() {
    leftArrow.style.display = slider.scrollLeft > 0 ? "flex" : "none";
    rightArrow.style.display =
      slider.scrollLeft < slider.scrollWidth - slider.clientWidth - 1
        ? "flex"
        : "none";
  }

  function scrollSlider(direction) {
    const visibleCount = getVisibleItemsCount();
    const itemWidth = items[0].offsetWidth;
    const scrollAmount = visibleCount * itemWidth * direction;

    slider.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });

    // Wait for the scroll to complete before updating arrow visibility
    setTimeout(updateArrowVisibility, 300);
  }

  leftArrow.addEventListener("click", () => scrollSlider(-1));
  rightArrow.addEventListener("click", () => scrollSlider(1));

  // Update arrow visibility on scroll
  slider.addEventListener("scroll", updateArrowVisibility);

  // Update arrow visibility on window resize
  window.addEventListener("resize", () => {
    updateArrowVisibility();
  });

  // Initial arrow visibility
  updateArrowVisibility();
});
